import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import Cookie from "js-cookie"

const IframeBasicReservation = () => {
    const { businessId } = useParams();
    const [formData, setFormData] = useState({
      business: businessId || "", // Zajištění, že businessId nebude undefined
      date: "",
      numberOfPeople: "",
      item: "",
      table:"",
    });
    const [sending, setSending] = useState(false)

    const [message, setMessage] = useState(null);
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value,
      });
    };
    const [quest, setQuest] = useState({
        name: "",
        phone: "",
        email: "",
    })



    const handleQuestChange = (e) => {
        const {name, value} = e.target

        setQuest((prev) => ({
            ...prev,
            [name]: value,
        }))
    } 
    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Měsíce začínají od 0, proto přičítáme 1
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      };
    const handleDateChange = (date) => {
      setFormData((prev) => ({
        ...prev,
        date: formatDate(date), // Formátování date na 'yyyy-MM-dd'
      }));
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();

      if (quest) {
        try {
            setSending(true)
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/basic-reservation/quest-create`,
            { ...formData, quest, time: selectedSlot }, 
          );
          
          setMessage(response.data.message);
          setQuest({
            name: "",
            phone: "",
            email: "",
        })
        setFormData({
            business: businessId || "",
            date: "",
            numberOfPeople: "",
            item: "",
            table:"",
          })
         Cookie.set("quest", JSON.stringify(quest), {expires: 365})
        } catch (err) {
          setMessage(err.response?.data?.message || "Něco se pokazilo");
        } finally {
            setSending(false)
          setTimeout(() => {
            setMessage(null)
          }, 1500)
        }
      }
    };
    // Vypsání slotů
  const [availableSlots, setAvailableSlots] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState("");

  useEffect(() => {
    const fetchAvailableSlots = async () => {
        
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/basic-reservation/available-slots`,
          {
            params: { businessId },
          }
        );
        setAvailableSlots(response.data);

      } catch (err) {
        console.log(err.response?.data?.message || "Chyba při načítání dat");
      }
    };

    if (businessId) {
      fetchAvailableSlots();
    }
  }, [businessId]);
  
  // Porovnání formátovaných dat
  const filteredSlots = availableSlots.filter(slot => formatDate(new Date(slot.date)) === formData.date);
  // Funkce pro formátování data na 'yyyy-MM-dd'

  const handleSlotChange = (e) => {
    setSelectedSlot(e.target.value);
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      date: formatDate(new Date())
    }))
  }, [])

  useEffect(() => {
    const savedQuest = Cookie.get("quest")
    if (savedQuest) {
        try {
            const parsedQuest = JSON.parse(savedQuest)
            setQuest(parsedQuest)
        } catch (err) {
            console.error("Chyba při čtení cookie quest:", err);
        }
    }
  }, [])

  return (
    <div className='business-container'>
<form onSubmit={handleSubmit}>
        <Calendar onChange={handleDateChange} />
        <div className="basic-container">
          <h2 className="check-title">Kdy:</h2>
          {filteredSlots.length === 0 ? (
            <p>Žádné dostupné sloty</p>
          ) : (
            <select value={selectedSlot} onChange={handleSlotChange} className="basic-input reservation-select">
              <option value="">Vyberte čas příchodu</option>
              {filteredSlots.map((slot, index) => (
                <optgroup key={index} label={`${slot.date} - ${slot.dayOfWeek}`}>
                  {slot.workHours.map((hour, i) => (
                    <option key={i} value={hour.startTime}>
                      {hour.startTime}
                    </option>
                  ))}
                </optgroup>
              ))}
            </select>
          )}
        </div>
      {quest ? <div>
        <div className="basic-container">
      <h2 className="check-title">Jméno a příjmení:</h2>
        <input
          className="basic-input hotel-input"
          type="text"
          name="name"
          value={quest.name}
          onChange={handleQuestChange}
          required
        />
      </div>
      <div className="basic-container">
      <h2 className="check-title">Telefon:</h2>
        <input
          className="basic-input hotel-input"
          type="number"
          name="phone"
          value={quest.phone}
          onChange={handleQuestChange}
          required
        />
      </div>
      <div className="basic-container">
      <h2 className="check-title">Email:</h2>
        <input
          className="basic-input hotel-input"
          type="email"
          name="email"
          value={quest.email}
          onChange={handleQuestChange}
          required
        />
      </div>
</div> : <div className='forwarding'>
            <p>Pokračujete jako {quest.name}</p>
        </div>}
      <div className="basic-container">
      <h2 className="check-title">Počet osob:</h2>
        <input
          className="basic-input hotel-input"
          type="number"
          name="numberOfPeople"
          placeholder="Počet osob"
          value={formData.numberOfPeople}
          onChange={handleChange}
          required
        />
      </div>
      <div className="basic-container">
      <h2 className="check-title">Poznámka:</h2>
        <input 
        className=" basic-input hotel-input"
          type="text"
          name="item"
          placeholder="Poznámka"
          value={formData.item}
          onChange={handleChange}
        />
        </div>
         <button type="submit" className="hotel-submit-button">{ sending ? "Vytvářím.." : "Potvrdit"}</button>
         {message && <p className="message">{message}</p>}
        </form>

        <div className='powered'><p>powered by </p><a href="https://resanio.com" target="_blank" rel="noopener noreferrer">
            RESANIO.com
        </a></div>
    </div>
  )
}

export default IframeBasicReservation